import api from './';

export default {
  getProjects() {
    return api.post('Projects/GetList', {}).then(response => response.data);
  },

  getProject(arg) {
    return api.post('Projects/Get', { projectGuid: arg }).then(response => response.data);
  },

  saveProject(arg) {
    return api.post('Projects/Save', { project: arg }).then(response => response.data);
  },
  searchProject(arg) {
    return api.post('Projects/Search', { search: arg }).then(response => response.data);
  },

  deleteProject(arg) {
    return api.post('Projects/Delete', { projectGuid: arg }).then(response => response.data);
  },
};
